<template>
  <div>
    <options />
    <router-view />
  </div>
</template>

<script>
import Options from "views/customer/childComps/publics/Options";
export default {
  name: "international",
  components: {
    Options
  }
}
</script>

<style scoped lang="scss"></style>